(function () {
  if (window.InteractiveRackV3Loaded) return;
  window.InteractiveRackV3Loaded = true;

  function initRack(root) {
    if (!root || root.dataset.rackReady === 'true') return;
    const track = root.querySelector('[data-rack-track]');
    const items = Array.from(root.querySelectorAll('[data-rack-item]'));
    if (!track || !items.length) return;
    root.dataset.rackReady = 'true';
    const title = root.querySelector('[data-rack-title]');
    const price = root.querySelector('[data-rack-price]');
    const link = root.querySelector('[data-rack-link]');
    const current = root.querySelector('[data-rack-current]');
    const total = root.querySelector('[data-rack-total]');
    const desktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = Math.floor((items.length - 1) / 2);
    let scrollRaf = null;
    let informationTimer = null;
    let resizeTimer = null;
    let mouse = null;
    let touch = null;
    let suppressUntil = 0;
    const isDesktop = () => desktopPointer.matches && window.innerWidth >= 990;
    const pad = n => String(n).padStart(2, '0');
    if (total) total.textContent = pad(items.length);

    function valuesForDistance(distance, direction) {
      if (distance === 0) return { scale: 1.14, x: 0, y: 0, opacity: 1, z: 20 };
      if (distance === 1) return { scale: 0.96, x: direction * 28, y: 5, opacity: 1, z: 15 };
      if (distance === 2) return { scale: 0.88, x: direction * 15, y: 9, opacity: 0.97, z: 10 };
      return { scale: 0.82, x: direction * 6, y: 12, opacity: 0.93, z: 5 };
    }
    function updateInformation(item) {
      window.clearTimeout(informationTimer);
      // Keep the destination synchronized even during the text transition.
      if (link) link.href = item.dataset.productUrl || '#';
      [title, price].forEach(el => {
        if (el) { el.style.opacity = '0'; el.style.transform = 'translateY(5px)'; }
      });
      informationTimer = window.setTimeout(function () {
        if (title) title.textContent = item.dataset.productTitle || '';
        if (price) price.textContent = item.dataset.productPrice || '';
        [title, price].forEach(el => {
          if (el) { el.style.opacity = '1'; el.style.transform = 'translateY(0)'; }
        });
      }, reduceMotion.matches ? 0 : 100);
      if (current) current.textContent = pad(activeIndex + 1);
    }
    function activate(index, changeInfo = true) {
      if (index < 0 || index >= items.length) return;
      activeIndex = index;
      items.forEach(function (item, i) {
        const signed = i - index;
        const values = valuesForDistance(Math.abs(signed), Math.sign(signed));
        const visual = item.querySelector('[data-rack-visual]');
        if (visual) {
          visual.style.setProperty('--rack-scale', values.scale);
          visual.style.setProperty('--rack-x', values.x + 'px');
          visual.style.setProperty('--rack-y', values.y + 'px');
          visual.style.setProperty('--rack-opacity', values.opacity);
          visual.style.setProperty('--rack-z', values.z);
        }
        item.classList.toggle('is-active', i === index);
        item.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      if (changeInfo) updateInformation(items[index]);
    }
    function centerItem(index, smooth = true) {
      if (isDesktop()) return;
      const itemRect = items[index].getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      const destination = track.scrollLeft + itemRect.left + itemRect.width / 2
        - trackRect.left - track.clientLeft - track.clientWidth / 2;
      track.scrollTo({ left: destination, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'instant' });
    }
    function closestItemToCenter() {
      const rect = track.getBoundingClientRect();
      const center = rect.left + track.clientLeft + track.clientWidth / 2;
      let nearest = activeIndex;
      let smallest = Infinity;
      items.forEach(function (item, i) {
        const r = item.getBoundingClientRect();
        const distance = Math.abs(r.left + r.width / 2 - center);
        if (distance < smallest) { smallest = distance; nearest = i; }
      });
      return nearest;
    }
    function requestScrollUpdate() {
      if (scrollRaf !== null) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = null;
        if (isDesktop()) return;
        const nearest = closestItemToCenter();
        if (nearest !== activeIndex) activate(nearest);
      });
    }
    items.forEach(function (item, index) {
      item.addEventListener('mouseenter', function () {
        if (isDesktop()) activate(index);
      });
      item.addEventListener('focus', function () {
        // Pointer focus must not center an item during a swipe or before a tap.
        if (!item.matches(':focus-visible') || mouse || touch) return;
        activate(index);
        if (!isDesktop()) centerItem(index);
      });
      item.addEventListener('click', function (event) {
        if (event.detail !== 0 && (Date.now() < suppressUntil || (mouse && mouse.dragging))) {
          event.preventDefault();
          return;
        }
        // One click handler for touch, mouse and keyboard: no touchend navigation.
        if (!isDesktop() && event.detail !== 0 && index !== activeIndex) {
          event.preventDefault();
          activate(index);
          centerItem(index);
          return;
        }
        const url = item.dataset.productUrl;
        if (url) window.location.href = url;
      });
    });

    // Touch handlers only observe movement. Native momentum and CSS snap remain untouched.
    track.addEventListener('touchstart', function (event) {
      const point = event.touches[0];
      if (!point) return;
      suppressUntil = 0;
      touch = { x: point.clientX, y: point.clientY, moved: event.touches.length > 1 };
    }, { passive: true });
    track.addEventListener('touchmove', function (event) {
      if (!touch) return;
      const point = event.touches[0];
      if (!point) return;
      if (event.touches.length > 1 || Math.hypot(point.clientX - touch.x, point.clientY - touch.y) > 10) {
        touch.moved = true;
      }
    }, { passive: true });
    track.addEventListener('touchend', function (event) {
      if (touch) {
        const point = event.changedTouches[0];
        if (point && Math.hypot(point.clientX - touch.x, point.clientY - touch.y) > 10) touch.moved = true;
        if (touch.moved) suppressUntil = Date.now() + 700;
      }
      if (!event.touches.length) touch = null;
    }, { passive: true });
    track.addEventListener('touchcancel', function () {
      touch = null;
      suppressUntil = Date.now() + 700;
    }, { passive: true });

    // Register mouse drag on hybrid devices too; never capture a touch pointer.
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || isDesktop()) return;
      suppressUntil = 0;
      mouse = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, dragging: false };
    });
    track.addEventListener('pointermove', function (event) {
      if (!mouse || event.pointerId !== mouse.id) return;
      const dx = event.clientX - mouse.x;
      const dy = event.clientY - mouse.y;
      if (!mouse.dragging && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(dy)) {
        mouse.dragging = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(event.pointerId); } catch (_) {}
      }
      if (!mouse.dragging) return;
      event.preventDefault();
      track.scrollLeft = mouse.left - dx;
      requestScrollUpdate();
    }, { passive: false });
    function finishDrag(event) {
      if (!mouse || event.pointerId !== mouse.id) return;
      const wasDragging = mouse.dragging;
      mouse = null;
      track.classList.remove('is-dragging');
      try { if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId); } catch (_) {}
      if (wasDragging) {
        suppressUntil = Date.now() + 700;
        const nearest = closestItemToCenter();
        activate(nearest);
        centerItem(nearest);
      }
    }
    window.addEventListener('pointerup', finishDrag);
    window.addEventListener('pointercancel', finishDrag);
    track.addEventListener('lostpointercapture', finishDrag);
    track.addEventListener('scroll', requestScrollUpdate, { passive: true });
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        activate(activeIndex, false);
        centerItem(activeIndex, false);
      }, 120);
    }, { passive: true });
    activate(activeIndex);
    window.requestAnimationFrame(function () { centerItem(activeIndex, false); });
  }
  function initAll() {
    document.querySelectorAll('[data-interactive-rack-v3]').forEach(initRack);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (event) {
    const target = event.target;
    if (!target || !target.querySelectorAll) return;
    if (target.matches('[data-interactive-rack-v3]')) initRack(target);
    target.querySelectorAll('[data-interactive-rack-v3]').forEach(initRack);
  });
})();
